<nav class="navbar navbar-expand-lg navbar-dark fixed-top  " >


  <div class="container" >

    <a class="navbar-brand" routerLink='/' routerLinkActive='active' >
      <img
        src="../../../assets/De-Partsmanagers3-Logo.png"
        alt="..."
        width="250" />
      </a>
      <ul class="navbar-nav mr-auto align-items-end" >
        @if (customerService.isLoggedIn$ | async) {
          <li class="nav-item">
            <a class="nav-link" routerLink='/pricelist' routerLinkActive='active'>Pricelist</a>
          </li>
          @if (pricelistService.hasPromotion$ | async) {
            <li class="nav-item">
              <a class="nav-link" routerLink='/promotion' routerLinkActive='active'>Promo</a>
            </li>
          }
          <li class="nav-item">
            <a class="nav-link" routerLink='/download' routerLinkActive='active'>Downloads</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink='/order' routerLinkActive='active'><span class="notranslate">Order</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink='/import' routerLinkActive='active'>Import</a>
          </li>
        }

      </ul>

      <div class="center">
        DataXL
      </div>


      @if (customerService.isLoggedIn$ && (customerService.currentUser$ | async); as user) {
        <div class="dropdown" dropdown>
          <a class="dropdown-toggle text-dark" dropdownToggle>Welcome {{user.knownAs | titlecase}}</a>
          <div class="dropdown-menu mt-3" *dropdownMenu>
            <a class="dropdown-item" routerLink='/orderhistory'>Order History</a>
            <a class="dropdown-item" routerLink='/profile'>Edit Profile</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="logout()">Logout</a>
          </div>
        </div>
      }
    </div>

  </nav>

  @if (isPricelistRoute()) {
    <div class="fixed" style="width: 100%; margin: 0; padding: 0;">
      <carousel
        [itemsPerSlide]="8"
        [singleSlideOffset]="true"
        [interval]="3000"
        [showIndicators]="false"
        [showNavigationArrows]="false"
        style="width: 100%;">
        @for (img of images; track img) {
          <slide>
            <img [src]="img.path" style="display: block; width: 100%; height: 150px; object-fit: contain; margin: 0 auto;">
          </slide>
        }
      </carousel>
    </div>
  }
